import React, { useState } from "react";
import TrainingCoursesTable from "./TrainingCoursesTable";
import EmployeeProgressTable from "./EmployeeProgressTable";
import CustomTabs from "components/tabs/customTab";

export default function TrainingProgramTabs() {
  const [activeTab, setActiveTab] = useState("training-courses");

  const TabLabel = ({ text }) => (
    <div className="flex items-center justify-center ">
        <span className="text-sm font-medium">{text}</span>
    </div>
  );

  const tabOptions = [
    { label: <TabLabel text="Training Courses"  />, value: "training-courses" },
    { label: <TabLabel text="Employee Programs"  />, value: "employee-programs" },
  ];

  return (
    <div>

      <div className="w-[300px]">
        <CustomTabs
          tabs={tabOptions}
          activeTab={activeTab}
          onChange={setActiveTab}
          height="h-10"
        />
      </div>

      <div className="mt-6">
        {activeTab === "training-courses" && (
          <TrainingCoursesTable/>
        )}
        {activeTab === "employee-programs" && (
          <EmployeeProgressTable/>
        )}
      </div>
    </div>
  );
}
